"use strict";

module.exports = {
  CONTEXT_MENU_WRAPPER_CLASS: 'context-menu-content-wrapper'
};